import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';

registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeDe);
registerLocaleData(localeIt);


@Component({
  selector: 'upsc-date-range-selector',
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss'],
  
})
export class CustomDatePickerComponent implements OnInit {

  @Input() customDateRangeFormGroup: UntypedFormGroup;
  @Input() formattedStartDate: string;
  @Input() formattedEndDate: string;
  public sessionLanguage : string;
  public maxDate = new Date();

  public constructor(private translateService : TranslateService, 
                      private adapter: DateAdapter<any>,
                    ) {
    this.translateService.onLangChange.subscribe((event) => {
      this.updateDatePickerLang(event.lang);
      this.updateFormControls();
    });
  }

  public updateDatePickerLang(language: string){
    this.adapter.setLocale(language);
  }

  ngOnInit(): void {
    this.updateDatePickerLang(sessionStorage.getItem('lang'));

    this.customDateRangeFormGroup.addControl('startDate', new UntypedFormControl(this.formattedStartDate));
    this.customDateRangeFormGroup.addControl('endDate', new UntypedFormControl(new Date(this.formattedEndDate)));
  }

  updateFormControls() {
    const startDateControl = this.customDateRangeFormGroup.get('startDate');
    const endDateControl = this.customDateRangeFormGroup.get('endDate');
    
    if (startDateControl) {
      startDateControl.setValue(new Date(startDateControl.value)); // Ensure it's a Date object
    }
    if (endDateControl) {
      endDateControl.setValue(new Date(endDateControl.value)); // Ensure it's a Date object
    }
  }

}
